import type { AxisRange, AxisScale, XAxisMode } from '@neptune/shared/widgets-domain';

import { AttributeDefinition, AttributeType } from 'domain/experiment/attribute';

export const DEFAULT_HISTOGRAM_CONFIG: HistogramWidgetOptions = {
  xAxisMode: 'step',
  xAxisScale: 'linear',
  yAxisRange: undefined,
  xAxisRange: undefined,
};

export const compatibleAttributeTypes: AttributeType[] = ['histogramSeries'];

export const prefillAttributes: AttributeDefinition[] = [
  { name: 'step', type: 'floatSeries', predefined: true },
];

export type HistogramWidgetOptions = {
  xAxisMode: XAxisMode;
  xAxisScale: AxisScale;
  xAxisRange?: AxisRange;
  yAxisRange?: AxisRange;
  xAxisMetric?: AttributeDefinition;
};
